import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AutoComplete from 'material-ui/AutoComplete';
import FlatButton from 'material-ui/FlatButton';

import ReduxDialog from '../Common/ReduxDialog';
import { customizedFuzzyFilter, toArray } from '../../utils/helper';

import commonStyles from '../styles';
import styles from './styles';

const permissionDSConfig = {
  text: 'name',
  value: 'id',
};

class AssignPermissionDialog extends React.Component {
  static propTypes = {
    onRequestClose: PropTypes.func.isRequired,
    permissions: PropTypes.array.isRequired,
  };

  state = {};

  handleSelectPermission = (permission) => {
    console.log('handleSelectPermission', permission);
    this.setState({ permission });
  };

  render() {
    const { permissions } = this.props;

    const actions = [
      <FlatButton
        label="Cancel"
        onClick={() => this.props.onRequestClose()}
      />,
      <FlatButton
        label="Add"
        primary
        keyboardFocused
        onClick={() => this.props.onRequestClose(this.state.permission)}
      />,
    ];

    return (
      <ReduxDialog
        name="assignPermission"
        title="Assign Permission"
        actions={actions}
        bodyStyle={styles.body}
      >
        <form>
          <AutoComplete
            name="permission"
            style={commonStyles.input}
            searchText={this.state.permissionSearchText}
            dataSource={permissions}
            dataSourceConfig={permissionDSConfig}
            filter={customizedFuzzyFilter}
            floatingLabelFixed
            floatingLabelText="Permission"
            openOnFocus
            onUpdateInput={this.handleUpdateInput}
            onNewRequest={this.handleSelectPermission}
            fullWidth
          />
        </form>
      </ReduxDialog>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    permissions: toArray(state.get('static').get('permissions').toJS()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignPermissionDialog);


// WEBPACK FOOTER //
// ./src/components/AssignPermissionDialog/index.js